(function() {
  
  angular
	.module('meanApp')
	.controller('profileRecipesCtrl', profileRecipesCtrl);

  profileRecipesCtrl.$inject = [
        '$scope',
        '$location', 
        '$state', 
        '$rootScope',
        'recipesManager',
        'utils',
        'searchModal'];
  function profileRecipesCtrl(
        $scope, 
        $location, 
        $state, 
        $rootScope, 
        recipesManager,
        utils,
        searchModal) {

	console.log('in the profile controller');
	console.log('state params are ', $state);
    var vm = this,
    APIFunctionToCall = recipesManager.getAllRecipesFromUser;
    this._currentPage = 1;
    this._nbPages = 1;//nb of pages in back end
    $scope.$parent._callBeingPerformed = false;
    vm.emptyResultDefaultMessage = "Vous n'avez pas encore de recettes !";
    vm.showRecipeCreation = true;

    switch ($state.current.name) {
        case 'profile.likes': 
            APIFunctionToCall = recipesManager.getAllRecipesLikedFromUser;
            vm.emptyResultDefaultMessage = 'Aucune recette aimée pour le moment !';
            vm.showRecipeCreation = false;
            break;
        case 'profile.bookmarks': 
            APIFunctionToCall = recipesManager.getAllRecipesBookmarkedFromUser; 
            vm.emptyResultDefaultMessage = 'Aucune recette sauvegardée pour le moment !';
            vm.showRecipeCreation = false;
            break;
    }

    var getContainerWidth = function() {
        if(!this._width) {
            this._width = angular.element(document.querySelector('.profile-submenu-container'))[0].offsetWidth;
        }
        console.log('the width is the following', this._width);
        return this._width;
    };  

    var launchCall = function() {
        //init sequence below
        $scope.$parent._callBeingPerformed = true;
        //here check which API needs to be called
        console.log('state of profile controler is', $state.current);
        //recipesManager.getAllRecipesFromUser($state.params.id, this._currentPage)
        //recipesManager.getAllRecipesLikedFromUser($state.params.id, this._currentPage)
        APIFunctionToCall.apply(recipesManager, [$state.params.id, this._currentPage])
        .then(function(obj) {
            this._nbPages = obj.nbPage;
            //console.log('results of recipes of a given user', recipes);
            $scope.$parent._callBeingPerformed = false;
            obj.recipes.forEach(function(recipe) {
                //recipe.isFolded = true;
                recipe.tags = recipe.tags.reverse();
                recipe.isCrossHidden = false;
            });

            //if(this._currentPage === 1) {
                vm.recipes = obj.recipes;
            //}
            //else {
            //    vm.recipes = vm.recipes.concat(obj.recipes);
            //}
            
            this._createArraysOfRecipes();
        
        }.bind(this), function(err) {
            console.log('erreur loading recipes profiles');
            console.log(err)
        });
    }.bind(this);

    launchCall();

    this.addOnScrollListener = function(cssSelector) {
        var scrollContainer = document.querySelector(cssSelector);
        if (scrollContainer) {
            //add a debounce so it is called only when the scroll has ended
            scrollContainer.onscroll = utils.debounce(function() {
                console.log('website container has scrolled');
                //if scroll is close to the end then make the next call
                //do not call if not in the end
                //must be on the proper page so this will fix some issues but not sure that if we gor from one page to another that would work like expected...
                if(['profile.recipes',  'profile.likes', 'profile.bookmarks', ].indexOf($state.current.name) > -1) {
                    if(this._currentPage < (this._nbPages)
                        &&!vm._callBeingPerformed 
                        && (scrollContainer.scrollHeight - scrollContainer.scrollTop) < (scrollContainer.offsetHeight + 100)) {

                        this._currentPage++;
                        launchCall();
                    }
                }
                
            }.bind(this), 200);
        }
    };

    this.addOnScrollListener('.website-container');
    this.addOnScrollListener('body');

    var checkContainer= function(finalContent, callback) {
        if(!finalContent.offsetHeight) {
           window.setTimeout(function() {
                console.log('recheck the container offsetHeight');
                checkContainer(finalContent, callback);
           }, 20); // this checks the flag every 100 milliseconds
        } else {
            callback();
        }
    };

    vm.goToRecipe = function(recipe) {
        if(recipe.isDraft === true) {
            $state.go('recipecreationstep', {
	        	id: recipe.slug,
	        	step: '1'
	      	});
        }
        else {
            $state.go('recipe', {
                id: recipe.slug
            });
        }
    };

    vm.goToIntermediateSearch = function() {
        searchModal.open();
    };

    vm.goToRecipeCreation = function() {
        $state.go('recipecreation');
    };


    this._numberOfColumns = 0;
    this._gutterSize = 20;
    this._maxItemSize = 300;
    this._minItemSize = 150;//maybe enlarge the size of the items ?

    //contains the conf of the columns
    this._columns = [];

    this._createArraysOfRecipes = function() {
        if(!this._numberOfColumns) {
            this._computeNumberOfColumns();
            //TODO not reinit the array but concat the recipes 
            vm.arrayOfRecipes = [];
            //Init the arrays
            for(var i = 0, l= this._columns.length; i<l ; i++) {
                vm.arrayOfRecipes.push([]);
            }
        }
       
        //dispatch the recipes on columns
        vm.recipes.forEach(function(recipe, index) {
            //push the recipe in the proper column
            var indexOfColumn = index%this._columns.length;
            vm.arrayOfRecipes[indexOfColumn].push(recipe);
        }.bind(this));
    };

    vm._computeNumberOfColumns = function() {
        var x = 1, 
        itemWidth;

        console.log('will compute the number of columns');
        for(var i = 1; i< 4; i++) {
            
            //if this x fulfill all conditions then break the loop
            //remove the gutters
            itemWidth = (getContainerWidth.apply(this)- 60*i)/i;
            if(itemWidth  <= this._maxItemSize && itemWidth >= this._minItemSize) {
                x = i;
                break;
            }
            //otherwise continue
        }

        this._numberOfColumns = x;
        /*this._cardPixelWidth = itemWidth;*/ 
        //init the columns conf and position system 
        for(var j= 0; j< x; j++) {
            console.log('in the loop for computing columns');
            this._columns.push({
                //lastPositionBottom : 0
            });
        }
    };

  }

})();